import { useUserData } from '../contexts/UserDataContext';

export function TradeHistoryTab() {
  const { trades, isConnected, isInitialLoad } = useUserData();

  const showEmptyState = !isConnected || (isInitialLoad && trades.length === 0) || trades.length === 0;
  const emptyMessage = !isConnected
    ? 'Connect wallet to view trade history'
    : isInitialLoad && trades.length === 0
    ? 'Loading trade history...'
    : 'No trade history';

  const formatTime = (timestamp: number) => {
    const date = new Date(timestamp);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${month}/${day}/${year} - ${hours}:${minutes}:${seconds}`;
  };

  return (
    <div className="h-full bg-[#0e0f10]">
      <table className="w-full">
        <thead>
          <tr className="border-b border-[#1a1d20]">
            <th className="px-3 py-3 text-left text-[12px] font-medium text-[#6c7884] tracking-wide">
              Time
            </th>
            <th className="px-3 py-3 text-left text-[12px] font-medium text-[#6c7884] tracking-wide">
              Market
            </th>
            <th className="px-3 py-3 text-left text-[12px] font-medium text-[#6c7884] tracking-wide">
              Side
            </th>
            <th className="px-3 py-3 text-right text-[12px] font-medium text-[#6c7884] tracking-wide">
              Size
            </th>
            <th className="px-3 py-3 text-right text-[12px] font-medium text-[#6c7884] tracking-wide">
              Price
            </th>
            <th className="px-3 py-3 text-right text-[12px] font-medium text-[#6c7884] tracking-wide">
              Fee
            </th>
            <th className="px-3 py-3 text-right text-[12px] font-medium text-[#6c7884] tracking-wide">
              Realized PnL
            </th>
            <th className="px-3 py-3 text-right text-[12px] font-medium text-[#6c7884] tracking-wide">
              Tx
            </th>
          </tr>
        </thead>
        <tbody>
          {showEmptyState ? (
            <tr>
              <td colSpan={8} className="px-3 py-8 text-center text-[#6c7884] text-[13px]">
                {emptyMessage}
              </td>
            </tr>
          ) : (
            trades.map((trade, idx) => {
            const isBuy = trade.dir === 'Open Long' || trade.dir === 'Close Short';
            const pnl = parseFloat(trade.closedPnl);

            return (
              <tr key={idx} className="hover:bg-[#13141a] transition-colors">
                <td className="px-3 py-3 text-[#6c7884] text-[12px]">
                  {formatTime(trade.time)}
                </td>
                <td className="px-3 py-3 text-white font-medium text-[12px]">
                  {trade.coin}
                </td>
                <td className="px-3 py-3">
                  <span className={`text-[12px] font-medium ${
                    isBuy ? 'text-[#0ecb81]' : 'text-[#f6465d]'
                  }`}>
                    {isBuy ? 'Buy' : 'Sell'}
                  </span>
                </td>
                <td className="px-3 py-3 text-right text-white text-[12px]">
                  {parseFloat(trade.sz).toFixed(4)}
                </td>
                <td className="px-3 py-3 text-right text-white text-[12px]">
                  ${parseFloat(trade.px).toFixed(2)}
                </td>
                <td className="px-3 py-3 text-right text-[#6c7884] text-[12px]">
                  ${parseFloat(trade.fee).toFixed(3)}
                </td>
                <td className={`px-3 py-3 text-right text-[12px] ${
                  pnl > 0 ? 'text-[#0ecb81]' : pnl < 0 ? 'text-[#f6465d]' : 'text-[#6c7884]'
                }`}>
                  {pnl !== 0 ? (pnl > 0 ? '+$' : '-$') + Math.abs(pnl).toFixed(2) : '-'}
                </td>
                <td className="px-3 py-3 text-right text-[#6c7884] text-[12px]">
                  {trade.tid ? `#${trade.tid}` : '-'}
                </td>
              </tr>
            );
          })
          )}
        </tbody>
      </table>
    </div>
  );
}
